import { updateDistrict } from "../../../../../actions/Utilities/District";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { editStateDistrict } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useUpdateDistrict = () => {
  const queryClient = useQueryClient();
  const [, setActionEditState] = useRecoilState(editStateDistrict);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation(
    (districtNewData) => updateDistrict(districtNewData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire(
            "Saving Failed",
            "District Name or District Code already exists!",
            "warning"
          );
        } else {
          queryClient.invalidateQueries(["GetDistrict"]);
          sendEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                if (res.status === 400) {
                  toast.fire(
                    "Success",
                    "District Updated Successfully, but failed in sending email",
                    "warning"
                  );
                } else {
                  toast.fire(
                    "Success",
                    "District Updated Successfully",
                    "success"
                  );
                }
              }
            },
          });
          setActionEditState(false);
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Update District!", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateDistrict;
